import http from "../helpers/http";
import https from "../helpers/https";

export const getTransactions = async (page, pageSize, payload) => {
  const response = await http().post(
    `/Transaction/List?pageNumber=${page}&pageSize=${pageSize}`,
    payload
  );
  return response.data;
};

export const getTransactionsSandBox = async (page, pageSize, payload) => {
  const response = await http().post(
    `/sandbox/transactions/list?pageNumber=${page}&pageSize=${pageSize}`,
    payload
  );
  return response.data;
};

export const getTotalCount = async (payload) => {
  const response = await http().post("/Transaction/Dashboard", payload);
  return response.data;
};

export const getTotalCountSandbox = async (payload) => {
  const response = await http().post("/sandbox/transactions/dashboard", payload);
  return response.data;
};

export const graphData = async () => {
  const response = await http().get("/Transaction/GetGraphData");
  return response.data.data;
};

export const getGraphDataSandbox = async () => {
  const response = await http().get("/sandbox/transactions/graph");
  return response.data.data;
};

export const getPaymentList = async () => {
  const response = await http().get("/PaymentLink/List");
  return response.data;
};

export const getSinglePaymentLinkInfo = async (id) => {
  const response = await http().get(`/PaymentLink/GetById/${id}`);
  return response.data;
};

export const updatePaymentLink = async (id, payload) => {
  const response = await https().post(`/PaymentLink/Update?id=${id}`, payload);
  return response.data;
};

export const viewSinglePaymentTransaction = async (id) => {
  const response = await http().get(`/PaymentLink/GetTransactions/${id}`);
  return response.data;
};

export const downloadTransaction = async (payload) => {
  const response = await http().post("/Transaction/Download", payload, {
    responseType: "blob",
  });
  return response;
};

export const getSettlementReport = async (
  startDate,
  endDate,
  pageNumber,
  pageSize
) => {
  const response = await http().get(
    `/SettlementReport/GetByDateRange?startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const downloadSettlementReport = async (
  startDate,
  endDate,
  pageSize
) => {
  const response = await http().get(
    `/SettlementReport/DownloadByDateRange?startDate=${startDate}&endDate=${endDate}&pageNumber=1&pageSize=${pageSize}`,
    {
      responseType: "blob",
    }
  );
  return response.data;
};
export const refundRequest = async (payload) => {
  const response = await http().post("/Refund/request", payload);
  return response.data;
};
export const refundRequestTest = async (payload) => {
  const response = await http().post("/sandbox/refunds/request", payload);
  return response.data;
};
export const getSplitSummary = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/Transaction/GetSplitSummary/split/summary${query ? `?${query}` : ''}`);
  return response.data;
};

export const getSplitSummarySandbox = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/sandbox/split/reports/summary${query ? `?${query}` : ''}`);
  return response.data;
};

export const getBeneficiarySummary = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/Transaction/GetBeneficiarySummary/split/beneficiaries${query ? `?${query}` : ''}`);
  return response.data;
};

export const getBeneficiarySummarySanbox = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/sandbox/split/reports/beneficiaries${query ? `?${query}` : ''}`);
  return response.data;
};

export const getSplitTransactions = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/Transaction/GetSplitTransactions/split/transactions${query ? `?${query}` : ''}`);
  return response.data;
};

export const getSplitTransactionsSanbox = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/sandbox/split/reports/transactions${query ? `?${query}` : ''}`);
  return response.data;
};

export const exportSplitReport = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/merchant/export${query ? `?${query}` : ''}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const exportSplitReportSandbox = async (params) => {
  const query = new URLSearchParams(Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined && v !== '')).toString();
  const response = await http().get(`/sandbox/split/reports/export${query ? `?${query}` : ''}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const getSplitConfiguration = async () => {
  const response = await http().get("/split/configuration");
  return response.data;
};

export const getSplitConfigurationSanbox = async () => {
  const response = await http().get("/sandbox/split/configs");
  return response.data;
};

export const saveSplitConfiguration = async (payload) => {
  const response = await http().post("/split/configuration", payload);
  return response.data;
};

export const saveSplitConfigurationSandbox = async (payload) => {
  const response = await http().post("/sandbox/split/config", payload);
  return response.data;
};

export const editSplitConfiguration = async (configId, payload) => {
  const response = await http().put(`/split/configuration/${configId}`, payload);
  return response.data;
};

export const editSplitConfigurationSandbox = async (configId, payload) => {
  const response = await http().put(`/sandbox/split/configurations/${configId}`, payload);
  return response.data;
};

export const getRefundsAll = async (isSandbox) => {
  const endpoint = isSandbox ? "/sandbox/refunds" : "/Refund/all";
  const response = await http().get(endpoint);
  return response.data;
};

export const getRefundsPending = async (isSandbox) => {
  const endpoint = isSandbox ? "/sandbox/refunds/pending" : "/Refund/pending";
  const response = await http().get(endpoint);
  return response.data;
};

export const getRefundsSettled = async (isSandbox) => {
  const endpoint = isSandbox ? "/sandbox/refunds/settled" : "/Refund/settled";
  const response = await http().get(endpoint);
  return response.data;
};

export const getRefundsInProgress = async (isSandbox) => {
  const endpoint = isSandbox ? "/sandbox/refunds/in-progress" : "/Refund/in-progress";
  const response = await http().get(endpoint);
  return response.data;
};